<template>
  <div class="fix-bottom">
    <van-button size="small" icon="arrow-up" @click="toggle"></van-button>
    <div class="download-block" :class="{ show: isShow}">
      <van-icon name="cross" color="#1989fa" size="40" @click="toggle"/>
      Download KKpoker
      <van-button>Download</van-button>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const isShow = ref(false);

function toggle() {
  isShow.value = !isShow.value;
}


</script>

<style lang="scss" scoped>
.fix-bottom {
  width: $containerWidth;
  position: fixed;
  left: fixedLeft();
  bottom: 0;
  text-align: left;

  @media (max-width: $containerWidth) {
    left: 0;
  }
}

.download-block {
  position: absolute;
  bottom: -50px;
  left: 0;
  height: 50px;
  width: 100%;
  background-color: greenyellow;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  transition: bottom 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
  &.show {
    bottom: 0;
  }
}
</style>
